module.exports = __webpack_public_path__ + "static/Background2-84bec8a00a2f8f743bfe28ee760211c2.jpg";